<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  

  <b-modal 
    v-if="hasActivePopup"
    v-model="showPopup"
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          @hidden="handlePopupHidden"
          >
          <CAPanel :__list="__list" v-if="showCA === true"></CAPanel>
          <Template :__object="showDevis"  v-if="showDevis !== null"></Template>
          <Manager ref="devisManager" v-if="showManagerItem !== null" :__item="showManagerItem" :__admin="admin" :__userList="[]" :__isAvoir="true" :__isSaving="onGoingReq.length > 0" :__onSave="onSave"></Manager>
  </b-modal>


  <div class="row pageHeader" v-if="!isLightMode">
  <div class="row subMenu">
    <b-button size="sm" variant="danger" style="float: right; margin: 5px" :class="{ activeFilterButton: showFilter }" @click.stop="toggleFilterPanel()">Filtrer</b-button>
    <b-button size="sm" variant="success" style="float: right; margin: 5px" @click="openCAPopup()">Chiffre d'affaire</b-button>
  </div>

    <FilterDrawerShell
      :show="showFilter"
      title="Filtres factures"
      :count="filtredListitems.length"
      @close="closeFilterPanel"
    >
      <template #sorts>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isDate.state)" icon="check-square-fill" @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"></b-icon>
          <span>Date</span>
          <b-icon class="redColor" v-if="sortFiltre.isDate.state" icon="recycle" @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
          <span>Nom</span>
          <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
          <span>Etat</span>
          <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
        </div>
      </template>

      <div class="filterField">
        <label>Société</label>
        <base-input
          placeholder="Société"
          v-model="filterContainer.keySearchSte"
          type="string"
        >
        </base-input>
      </div>
      <div class="filterField">
        <label>Exercice</label>
        <b-form-select
          v-model="filterContainer.filterExercice"
          :options="exerciceOptions"
          @change="handleExerciceChange"
        ></b-form-select>
      </div>
    </FilterDrawerShell>
  </div>

    <div :class="getMainPanel">

      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="isLightMode"
      >
        <div class="factureLightCard">
          <div class="factureLightIdentity">
            <div class="factureLightRef">{{ item.type }} N° {{ item.num }} / {{ item.exercice }}</div>
            <div class="factureLightMeta">{{ item.owner && item.owner.name ? item.owner.name : 'Client' }}</div>
          </div>
          <div class="factureLightAmount">
            <span>TTC</span>
            <b>{{ formatMoney(item.totalTTC) }}</b>
          </div>
          <div class="factureLightActions">
            <b-button size="sm" variant="primary" @click="setValide(item)" v-if="item.status === 'NOUVEAU' && isAllowRegle()">Réglée</b-button>
            <b-button size="sm" variant="info" @click="openTemplatePopup(item)">Voir</b-button>
          </div>
        </div>
      </div>


      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="!isLightMode"
      >
        <div class="factureCard">
          <div class="factureCardTop">
            <div class="factureCardIdentity">
              <div class="factureCardNumber">N° {{ item.num }} / {{ item.exercice }}</div>
              <div class="factureCardType">{{ item.type }}</div>
            </div>

            <div class="factureCardClient">
              <div class="factureCardDate">{{ __._getDate(item.createdAt) }}</div>
              <div class="factureCardOwner">{{ item.owner && item.owner.name ? item.owner.name : 'Client non renseigné' }}</div>
            </div>

            <div class="factureCardAmount">
              <span class="factureCardAmountLabel">Montant TTC</span>
              <b class="factureCardAmountValue">{{ formatMoney(item.totalTTC) }}</b>
            </div>
          </div>

          <div class="factureCardBody">
            <div class="factureInfoBlock factureArticlesBlock">
              <div class="factureInfoLabel">Articles</div>
              <div class="factureArticlesList" v-if="item.devis && item.devis.length">
                <div
                  v-for="(article, idx) in item.devis"
                  :key="idx"
                  class="factureArticleRow"
                >
                  <span class="factureArticleQty">{{ article.qte }}</span>
                  <span class="factureArticleRef">{{ article.ref }}</span>
                  <span class="factureArticleName">{{ article.name }}</span>
                </div>
              </div>
              <div class="factureEmptyText" v-else>Aucune ligne facture.</div>
            </div>

            <div class="factureInfoBlock factureAvoirsBlock">
              <div class="factureInfoLabel">Avoirs liés</div>
              <div class="devisList">
                <Listfact :isLightMode="true" :PID="item._id" :ref="'avoir'+item._id"></Listfact>
              </div>
            </div>
          </div>

          <div class="factureCardBottom">
            <div class="factureNotif" v-if="item.notif">{{ item.notif }}</div>
            <div class="factureActions">
              <b-button size="sm" variant="success" @click="openTemplatePopup(item)">Voir la facture</b-button>
              <b-button size="sm" variant="primary" @click="setValide(item)" v-if="isAllowRegle() && item.status === 'NOUVEAU'">Réglée</b-button>
              <b-button size="sm" variant="info" @click="addAvoir(item)" v-if="isAllowAvoirAdd()">Ajouter avoir</b-button>
              <ico-btn
                v-if="canDeleteItem(item)"
                size="p"
                type="warning"
                icone="trash"
                title="Supprimer"
                :cb="
                  () => {
                    dispatchDelete(item._id);
                  }
                "
              ></ico-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";

import Listfact from "@/pages/avoirs";
import Template from "@/pages/commun/Template";
import Manager from '@/pages/commun/Manager';
import CAPanel from './CAPanel';
import FilterDrawerShell from "@/components/FilterDrawerShell.vue";

export default {

  components: {
    Template,
    Manager,
    Listfact,
    CAPanel,
    FilterDrawerShell
  },
  props: {
    isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },

  },

  data() {
    return {
      filterContainer: { keySearchSte: "", filterExercice: "" },
      structure: {},
      showPopup:null,
      showFilter: false,
      admin: null,
      onGoingReq:[],
      filtredListitems: [],
      showManagerItem: null,
      showDevis: null,
      showCA: false,
      sortFiltre: {
        isDate: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    handleExerciceChange() {
      const archive = String(this.filterContainer.filterExercice || "").trim();

      if (!archive) {
        return;
      }

      Vue.$cookies.set("exercice", archive);
      this.$root.$emit("archive:changed", archive);
      this.$parent.loadData();
    },

    normalizeNum(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getLastDocumentId() {
      if (!Array.isArray(this.__list) || this.__list.length === 0) {
        return null;
      }

      const latestDocument = this.__list.reduce((selected, document) => {
        if (!document) {
          return selected;
        }

        if (!selected) {
          return document;
        }

        const currentNum = this.normalizeNum(document.num);
        const selectedNum = this.normalizeNum(selected.num);

        if (currentNum > selectedNum) {
          return document;
        }

        if (currentNum < selectedNum) {
          return selected;
        }

        const currentDate = new Date(document.createdAt || 0).getTime();
        const selectedDate = new Date(selected.createdAt || 0).getTime();

        return currentDate >= selectedDate ? document : selected;
      }, null);

      return latestDocument ? latestDocument._id : null;
    },

    isLastDocument(item) {
      return Boolean(item && item._id && item._id === this.getLastDocumentId());
    },

    canDeleteItem(item) {
      return !this.isLightMode && this.isAllowAvoirAdd() && this.isLastDocument(item);
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    resetPopupState() {
      this.showCA = false;
      this.showDevis = null;
      this.showManagerItem = null;
    },

    handlePopupHidden() {
      this.showPopup = false;
      this.resetPopupState();
    },

    openCAPopup() {
      this.resetPopupState();
      this.showCA = true;
      this.showPopup = true;
    },

    openTemplatePopup(item) {
      this.resetPopupState();
      this.showDevis = item;
      this.showPopup = true;
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },
    
    isAllowRegle() {
      if(this.admin && ['ROOT','ADMIN', 'COMMERCIAL'].includes(this.admin.type)) {
        return true
      } 
      return false
    },

    isAllowAvoirAdd() {
      if(this.admin && ['ROOT','ADMIN', 'COMMERCIAL'].includes(this.admin.type)) {
        return true
      } 
      return false
    },

    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];

      if (this.filterContainer.keySearchSte)
        ret = ret.filter((e) =>
        e.owner && e.owner.name && e.owner.name.includes(this.filterContainer.keySearchSte) 
        );

    
        if(this.sortFiltre.isDate.state === true) {
        if(this.sortFiltre.isDate.isUp)
          ret = ret.sort((a, b) => (new Date(a.createdAt)).getTime() - (new Date(b.createdAt)).getTime());
        else
        ret = ret.sort((a, b) => (new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime());
      }

        
      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String((a.owner && a.owner.name) || "").localeCompare(String((b.owner && b.owner.name) || "")));
        else
          ret = ret.sort((a, b) => String((b.owner && b.owner.name) || "").localeCompare(String((a.owner && a.owner.name) || "")));
      }



      if(this.sortFiltre.isActivated.state === true) {
        
        if(this.sortFiltre.isActivated.isUp)
          ret = ret.sort((a, b) => String(a.status).localeCompare(String(b.status)));
        else
          ret = ret.sort((a, b) => String(b.status).localeCompare(String(a.status)));
      }
      
      this.filtredListitems = ret.filter(e => e.name !== '');
      //return ret;
    },

    onSave() {
      if (this.onGoingReq.length > 0 || !this.showManagerItem) {
        return;
      }

      this.onGoingReq.push({});
      const currentPid = this.showManagerItem ? this.showManagerItem.pid : null;
      let $onNext = (response) => {
        this.showPopup = false;
        if (
          currentPid &&
          this.$refs['avoir'+currentPid] &&
          this.$refs['avoir'+currentPid][0]
        ) {
          this.$refs['avoir'+currentPid][0].loadData();
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this.showManagerItem
      this.$parent.updateAction({ $onNext, $onError, $onComplete, data });
    },

    addAvoir(item) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        const payload = response && response.data ? response.data : {};
        const createdAvoir = payload.avoir || null;
        const fn = () => {
          this.resetPopupState();
          this.showManagerItem = createdAvoir;
          this.showPopup = true;
        };
        if (createdAvoir) {
          fn();
        }
        if (this.$refs['avoir'+item._id] && this.$refs['avoir'+item._id][0]) {
          this.$refs['avoir'+item._id][0].loadData()
        }
        
      };

      const $onError = () => {
        this.$bvToast.toast(
          "L'avoir n'a pas pu être initialisé. Veuillez réessayer.",
          {
            title: "Génération d'avoir",
            variant: "danger",
            solid: true,
          }
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.__.httpAction({
        methode: 'POST',
        route: '/factures/setavoirfromfacture/' + item._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    setValide(item) {
      this.$bvModal
        .msgBoxConfirm("Facture réglée ? Une fois validée, la facture sera visible sur le compte client.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'VALIDE', 'status');
            this.$parent.setUpdateValue(item._id, 'Facture réglée et confirmée par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
          }
        });
    },


    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },

    formatMoney(value) {
      const amount = Number(value || 0);
      return `${amount.toFixed(3)} TTC`;
    },

    getState(state) {
      switch (state) {
        case 'NOUVEAU':
          return 'border-left: solid 10px #CCC;'
          break;

        case 'VALIDE':
          return 'border-left: solid 10px green;'
          break;
        case 'REJETE':
          return 'border-left: solid 10px red'
          break;
        default:
          break;
      }
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    exerciceOptions() {
      const currentYear = new Date().getFullYear();
      const options = [currentYear + 1, currentYear, currentYear - 1, currentYear - 2]
        .map((year) => String(year));

      if (this.filterContainer.filterExercice) {
        options.push(String(this.filterContainer.filterExercice));
      }

      return [...new Set(options)].map((year) => ({
        value: year,
        text: year,
      }));
    },

    hasActivePopup() {
      return this.showCA === true || this.showDevis !== null || this.showManagerItem !== null;
    },

    styleSublisteMode() {
      return (this.$props.isLightMode) ? "lightMode col-md-12" : "listeMode col-md-12";
    },

   

    getMainPanel() {
      return (this.isLightMode) ? "row mainPanelnoFilter" : "row mainPanelWithoutFilter";
    },

    
  },

  mounted() {
    setTimeout(()=>this.filtredList(),400);
    this.admin = Vue.$cookies.get("user");
    this.filterContainer.filterExercice = String(
      Vue.$cookies.get("exercice") || new Date().getFullYear()
    );
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        this.filtredList()
      },
    },

    __list: {
      deep: true,
      handler() {
        this.filtredList();
      },
    },
   
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        this.filtredList()
      },
    },

    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}

.factureLightCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
}

.factureLightIdentity {
  flex: 1 1 auto;
  min-width: 0;
}

.factureLightRef {
  color: #1e2a44;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.factureLightMeta {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}

.factureLightAmount {
  flex: 0 0 auto;
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #eff6ff 0%, #e4eefb 100%);
  border: 1px solid #cfe0f5;
  text-align: right;
}

.factureLightAmount span {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.factureLightAmount b {
  display: block;
  margin-top: 4px;
  font-size: 16px;
}

.factureLightActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.factureCard {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.factureCardTop {
  display: grid;
  grid-template-columns: minmax(0, 180px) minmax(0, 1fr) minmax(0, 190px);
  gap: 16px;
  align-items: stretch;
}

.factureCardIdentity,
.factureCardClient,
.factureCardAmount {
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
  border: 1px solid #e2e8f0;
}

.factureCardNumber {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.15;
}

.factureCardType {
  margin-top: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.factureCardDate {
  color: #94a3b8;
  font-size: 12px;
  margin-bottom: 8px;
}

.factureCardOwner {
  color: #1e2a44;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.factureCardAmount {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(180deg, #f0fdf4 0%, #e7f8ee 100%);
  border-color: #cdebd7;
}

.factureCardAmountLabel {
  color: #5f6f8b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.factureCardAmountValue {
  margin-top: 6px;
  color: #15803d !important;
  font-size: 24px;
  line-height: 1.1;
}

.factureCardBody {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
  gap: 16px;
}

.factureInfoBlock {
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.factureInfoLabel {
  margin-bottom: 12px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.factureArticlesList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.factureArticleRow {
  display: grid;
  grid-template-columns: 36px minmax(0, 160px) minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 10px 12px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 13px;
}

.factureArticleQty {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #1e2a44;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.factureArticleRef {
  color: #71829c;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-word;
}

.factureArticleName {
  color: #1e2a44;
  font-weight: 600;
  line-height: 1.5;
}

.factureEmptyText {
  color: #94a3b8;
  font-size: 13px;
}

.devisList {
  width: 100%;
}

.factureCardBottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.factureNotif {
  flex: 1 1 auto;
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
  border: 1px solid #fdba74;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.5;
}

.factureActions {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.lightMode {
  padding: 1%;
  margin-bottom: 12px;
  border-radius: 10px;
  background-color: #F2F2F2;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}
.mainPanelWithoutFilter {
  margin-top: 100px;
}

.mainPanelnoFilter {
  margin-top: 0px;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .serachPanel .form-control,
  .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .serachPanel [class*="col-"] {
    font-size: 15px;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .factureLightCard,
  .factureCardBottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .factureLightActions,
  .factureActions {
    width: 100%;
  }

  .factureLightActions .btn,
  .factureActions .btn {
    flex: 1 1 calc(50% - 8px);
  }

  .factureCardTop,
  .factureCardBody {
    grid-template-columns: 1fr;
  }

  .factureArticleRow {
    grid-template-columns: 28px 1fr;
  }

  .factureArticleName {
    grid-column: 1 / -1;
  }

  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .serachPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>

